<template>
  <v-dialog
    v-model="active"
    width="480"
    persistent
  >
    <v-card
      v-if="derivacion"
      class="card"
      color="primary"
    >
      <v-card-title>Emisión de resultados de evaluación</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="derivacionForm"
        >
          <v-text-field
            v-model="derivacion.oficioSolicitud"
            label="Oficio de solicitud"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          />
          <v-text-field
            :value="derivacion.fechaOficioSolicitud"
            label="Oficio de solicitud"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            readonly
          />
          <v-file-input
            v-model="fileSolicitud"
            label="Adjunto oficio solicitud"
            rounded
            filled
            background-color="primary"
            color="secondary"
            dense
            :rules="required"
          />
          <v-divider class="my-4" />
          <v-text-field
            v-model="derivacion.oficioRespuesta"
            label="Oficio de respuesta"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
          />
          <v-menu
            v-model="menuFechaRespuesta"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                :value="computedFechaRespuesta"
                label="Fecha de oficio de respuesta"
                prepend-icon="mdi-calendar"
                readonly
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="derivacion.fechaOficioRespuesta"
              @input="menuFechaRespuesta = false"
            />
          </v-menu>
          <v-file-input
            v-model="file"
            label="Adjunto oficio respuesta"
            rounded
            filled
            background-color="primary"
            color="secondary"
            dense
            :rules="required"
          />
          <v-divider class="my-4" />
          <v-text-field
            v-model="derivacion.resultado"
            label="Resultado"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
          />
          <v-textarea
            v-model="derivacion.observaciones"
            label="Observaciones"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
            no-resize
            rows="4"
          />
        </v-form>
        <v-list
          v-if="perfil === 'Integración'"
          dense
          color="transparent"
        >
          <v-list-item
            v-for="(resultado, index) in filteredResultados"
            :key="index"
          >
            <v-list-item-icon>
              <v-icon
                :color="resultado.fk_idCatEstatus === 1 ? 'error' : 'success'"
                small
              >
                {{ resultado.fk_idCatEstatus === 1 ? 'mdi-clock' : 'mdi-check' }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ getAreaName(resultado.fk_idEquipoApplication) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          color="error"
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
        <v-btn
          rounded
          color="secondary"
          :disabled="loading || !derivacionForm"
          @click="triggerUpdateDerivacion()"
        >
          Emitir resultados
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    active: {
      type: Boolean,
    },

    derivacion: {
      type: Object,
      required: true,
    },

    resultados: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      menuFechaRespuesta: false,
      menuFechaSolicitud: false,
      file: null,
      fileSolicitud: null,
      derivacionForm: false,
      required: [(v) => !!v || 'Este campo es requerido'],
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    computedFechaRespuesta() {
      return this.derivacion.fechaOficioRespuesta ? moment(this.derivacion.fechaOficioRespuesta).format('DD/MM/YYYY') : '';
    },

    filteredResultados() {
      if (this.resultados.length > 0) {
        return this.resultados.filter((resultado) => resultado.fk_idEquipoApplication !== 23);
      }

      return [];
    },
  },

  methods: {
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    closeDialog() {
      this.$refs.form.resetValidation();
      this.$emit('close');
    },

    async triggerUpdateDerivacion() {
      this.loading = true;
      this.derivacion.file = this.file;
      await this.updateDerivacion({
        fk_idProgramacion: this.derivacion.fk_idProgramacion,
        fechaAtendio: moment().format('DD/MM/YYYY'),
        idDerivacion: this.derivacion.idDerivacion,
        oficioSolicitud: this.derivacion.oficioSolicitud,
        fechaOficioSolicitud: this.derivacion.fechaOficioSolicitud,
        fk_idEquipoApplication: this.derivacion.fk_idEquipoApplication,
        fk_idCatEstatus: this.derivacion.fk_idCatEstatus,
        oficioRespuesta: this.derivacion.oficioRespuesta,
        fechaOficioRespuesta: moment(this.derivacion.fechaOficioRespuesta).format('DD/MM/YYYY'),
        resultado: this.derivacion.resultado,
        adjuntoOficioSolicitud: this.fileSolicitud.name,
        adjuntoOficioRespuesta: this.file.name,
        fechaCerro: this.derivacion.fechaCerro,
        file: this.file,
        fileSolicitud: this.fileSolicitud,
        observaciones: this.derivacion.observaciones,
      });

      await this.updateEstatusDerivacion({
        fk_idProgramacion: this.derivacion.fk_idProgramacion,
        idDerivacion: this.derivacion.idDerivacion,
      });
      this.loading = false;

      await this.fetchDerivacionesByArea(this.derivacion.fk_idEquipoApplication);

      this.closeDialog();
    },

    getAreaName(areaId) {
      switch (areaId) {
        case 17:
          return 'Psicología';
        case 18:
          return 'Polígrafo';
        case 19:
          return 'Médico';
        case 20:
          return 'Entrevista ISE';
        case 21:
          return 'Antecedentes';
        case 22:
          return 'Validación';
        default:
          return '';
      }
    },
  },
};
</script>
